import { StandardAddons } from "./StandardAddons";
import { PremiumAddons } from "./PremiumAddons";
import AddOnSection from "../AddOnSection";
import { InlineCheckbox } from "../../fields";
import {
  FLOORPLAN_COLOR_SKUS,
  PREMIUM_FP_ADDON_SKUS,
} from "../../../helpers/constants";
export const FloorplanAddons = () => {
  return (
    <AddOnSection
      title="Floor Plan Add-Ons"
      show_skus={["2001", "2005", "2501"]}
      addon_skus={[
        "2901",
        "2010",
        ...FLOORPLAN_COLOR_SKUS,
        ...PREMIUM_FP_ADDON_SKUS,
        "standard_fp_addons",
        "premium_fp_addons",
      ]}
    >
      <InlineCheckbox sku="2901" />
      <StandardAddons />
      <PremiumAddons />
    </AddOnSection>
  );
};
